export enum EnumTipoTag {
  Marcacao = 0,
  Comentario = 1,
}
